import type { IconProps } from '@carboncopyco/icons';
import classNames from 'classnames';
import React from 'react';
import { ColorHex } from '../../constants';

export interface TileActionProps {
  title: string;
  illustration?: React.ReactNode;
  icon?: React.ReactElement<IconProps>;
  onClick?: () => void;
  background?: boolean;
}

export function TileAction({
  onClick,
  title,
  icon,
  illustration = 'actionDemo',
  background,
}: TileActionProps) {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'h-44 w-52 flex border-2 hover:border-ds-natural-50 hover:border-solid border-ds-natural-150 border-dashed rounded-md hover:bg-ds-natural-50 p-2.5 cursor-pointer active:bg-ds-natural-100',
        { 'bg-ds-natural-100': background }
      )}
    >
      <div className="flex flex-col w-full items-center pt-5">
        <div className="w-24 items-center ">{illustration}</div>
        <div className="flex pb-2.5 pt-3 items-center text-ds-primary-300 text-sm">
          {title}
        </div>
        <div className="flex items-center	rounded-full bg-ds-primary-300 p-0.5">
          {icon &&
            React.cloneElement(icon, {
              size: 13.5,
              color: ColorHex.accent3100,
            })}
        </div>
      </div>
    </div>
  );
}
